import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["isRounded"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Textfield from '@atlaskit/textfield';
import { NumberUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const NumericTextField = props => {
  const {
    min = Number.NEGATIVE_INFINITY,
    max = Number.POSITIVE_INFINITY
  } = props;
  const {
      isRounded
    } = props,
    passThroughProps = _objectWithoutProperties(props, _excluded);
  const handleChange = e => {
    var _props$onChange;
    const {
      value
    } = e.target;
    const numberVal = Number(value);
    const roundedVal = isRounded ? Math.round(numberVal) : numberVal;
    const clampedVal = NumberUtils.bindNumberInRange(roundedVal, min, max);
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, clampedVal);
  };
  return /*#__PURE__*/_jsx(Textfield, _objectSpread(_objectSpread({
    type: "number"
  }, passThroughProps), {}, {
    onChange: handleChange
  }));
};
export default NumericTextField;